<template>
  <div>
    <v-simple-table class="table-wrapper">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Date</th>
            <th class="text-left">Author</th>
            <th class="text-right">{{ node.meta.uom }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(n, index) in maxLength" :key="index">
            <td>
              {{ dateTimeLabel(values[values.length - n]) }}
            </td>
            <td>
              {{ displayAuthor(values[values.length - n]) }}
            </td>
            <td class="text-right">
              {{ displayData(values[values.length - n]) }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import moment from "moment";
import isArray from "lodash/isArray";

export default {
  props: {
    values: Array,
    node: Object
  },
  computed: {
    maxLength() {
      return Math.min(this.values.length, this.showValues);
    }
  },
  data() {
    return {
      showValues: 5
    };
  },
  methods: {
    reformatTimestamp(timestamp) {
      return moment(timestamp).format("MMM Do YYYY, h:mm a");
    },
    dateTimeLabel(value) {
      return `${this.reformatTimestamp(value.eventTimestamp)}${
        value.event ? `` : ""
      }`;
    },
    displayData(valueArray) {
      if (isArray(valueArray.val)) {
        const separator = this.node.meta.separator || ",";
        return valueArray.val.join(separator);
      } else {
        return valueArray.val;
      }
    },
    displayAuthor(value) {
      return value.authorName ? value.authorName : "";
    }
  }
};
</script>

<style scoped lang="scss">
.table-wrapper {
  border: $standard-border;
}
table {
  width: 100%;
}
</style>
